import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const MeetingPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Meeting}
        fetchRecordsUrl={AdminReqUrls.admin__meeting__mainPage_fetch_recordList}
        showMultipleDelete={true}
    />)
});
export default MeetingPage;
